import { Icon, IconProps } from "../";

export const NotebookCloseIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M17.7512 21.9983H6.24805C5.00586 21.9983 3.99805 20.9905 3.99805 19.7483V4.4999C3.99805 3.12178 5.11836 2.00146 6.49648 2.00146H18.4965C18.909 2.00146 19.2465 2.33896 19.2465 2.75146C19.2465 3.16396 18.909 3.50146 18.4965 3.50146H6.49648C5.94336 3.50146 5.49805 3.95146 5.49805 4.4999C5.49805 5.04834 5.94805 5.49834 6.49648 5.49834H17.7465C18.9887 5.49834 19.9965 6.50615 19.9965 7.74834V19.7483C20.0012 20.9905 18.9887 21.9983 17.7512 21.9983Z" />
    </Icon>
  );
};
